import classNames from 'classnames';
import _, { floor } from 'lodash';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Card, CardHeader } from 'reactstrap';
import { LoadingUnitIdentifier } from '.';
import { DeepPartialGraph } from '../types';
import { Terminal } from '../types/graph';

type StorageTimeCardProps = {
    // @ts-ignore
    terminal: DeepPartialGraph<Terminal>
};




//const Rows = styled.ul`
//    display: flex;
//    flex-direction: column;
//    list-style-type: none;
//    padding: 0;
//`;

//const Row = styled(Link)<{ color: 'warning' | 'danger' }>(({ theme, color }) => {
//    const baseColor = new Color(theme[color]);
//    const bgColor = baseColor;
//    const lightBg = bgColor.luminosity() > .5;
//    const activeBgColor = bgColor[lightBg ? 'darken' : 'lighten'](.1);
//    const lightActiveBg = baseColor.luminosity() > .5;
//    const txtColor = lightBg === true ? theme.black : theme.white;
//    const activeTxtColor = lightActiveBg === true ? theme.black : theme.white;

//    return `
//    color: ${ txtColor };
//    background-color: ${ bgColor };
//    padding: .25rem .5em;
//    display: flex;
//    justify-content: space-between;

//    :hover {
//        color: ${ activeTxtColor};
//        background-color: ${activeBgColor };
//        text-decoration: none;
//    }
//`;
//});

const StorageTimeCard = ({ terminal }: StorageTimeCardProps) => {
    const { t } = useTranslation('common');
    const handlings = terminal.handlings;
    const terminalSlug = terminal.slug;

    const maxStorageDays = terminal.maxStorageDays;
    const storageWarningDays = terminal.storageWarningDays;

    const tableRowsAndKo = useMemo(() => {
        if (handlings === undefined || terminalSlug === undefined) {
            return null;
        }

        const filterMin = storageWarningDays ?? maxStorageDays;
        const filterMax = maxStorageDays ?? Infinity;

        if (filterMin === null || filterMin === undefined) {
            return null
        }

        return _(handlings)
            .filter(({ acceptedForStorageOverTimeLimit, storageDays }) =>
                acceptedForStorageOverTimeLimit !== true
                && (storageDays !== undefined && storageDays !== null && storageDays > filterMin))
            .orderBy(['storageDays'], ['desc'])
            .reduce(({ rows, ko }, { id, loadingUnitIdentifier, storageDays }) => {
                const count = floor(storageDays as number);
                const exceeded = count >= (filterMax);

                const cn = classNames({
                    "list-group-item": true,
                    "d-flex": true,
                    "justify-content-between": true,
                    "list-group-item-warning": !exceeded,
                    "list-group-item-danger": exceeded
                })

                rows.push(<Link className={cn} key={id} color={exceeded ? 'danger' : 'warning'} to={`${terminalSlug}/unita-in-sosta/${loadingUnitIdentifier?.toLowerCase()}`}>
                    <LoadingUnitIdentifier identifier={loadingUnitIdentifier} />
                    <strong>{t('terminal.home.storageTime.daysCount', { count }) }</strong>
                </Link>);

                return { rows, ko: ko || exceeded }
            }, { rows: [], ko: false } as { rows: JSX.Element[], ko: boolean });

    }, [handlings, maxStorageDays, storageWarningDays, terminalSlug]);

    if (tableRowsAndKo === null) {
        return null;
    }

    const { rows, ko } = tableRowsAndKo;

    const ok = rows.length === 0;

    const statusIndicator = ok === true
        ? <span className='text-success'>{t('OK')}</span>//OK
        : ko === true
            ? <></>//KO
            : <></>//Warning

    if (ok) {
        return <h4>{t('Tempo di permanenza')}{' '}{statusIndicator}</h4>;
    }

    return <Card>
        <CardHeader>
            <h4 className={ko === true ? 'text-danger' : 'text-warning'}>
                {t('Tempo di permanenza')}
            </h4>
        </CardHeader>

        <div className="list-group list-group-flush">{rows}</div>
    </Card>
};


export default StorageTimeCard;